/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Image_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Export failed: {error}" |
*
* @param {Image_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_failed_toast = /** @type {((inputs: Image_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'exportation : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Export fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт не удался: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportación fallida: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`निर्यात विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportação falhou: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Export failed: ${i?.error}`)
});